import React from 'react';
import { c as classNames } from '../../../../index-e609ebf3.js';
import '../../../../_commonjsHelpers-17aad09c.js';

var GameControllersWr = function (_a) {
    var gameControllerType = _a.gameControllerType, popupRef = _a.popupRef, children = _a.children;
    var className = classNames('pgc-game-controllers', { open: gameControllerType });
    return (React.createElement("div", { ref: popupRef, className: className }, children));
};

export { GameControllersWr };
